import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import {animated, Spring} from 'react-spring';

import FilterNodeLabel from './FilterNodeLabel';
import styles from './FilterNodeTick.less';

class FilterNodeTick extends React.PureComponent {
  constructor() {
    super();
    this.handleTickClick = this.handleTickClick.bind(this);
    this.handleTickKeyDown = this.handleTickKeyDown.bind(this);
  }

  handleTickClick(event) {
    const {toggleOpened} = this.props;
    event.stopPropagation();
    toggleOpened();
  }

  handleTickKeyDown(event) {
    const {toggleOpened} = this.props;
    if (event.key === 'Enter' || event.key === ' ') {
      event.stopPropagation();
      toggleOpened();
    }
    return true;
  }

  render() {
    const {isOpened, label} = this.props;
    return (
      <span
        className={classNames(
          styles.dlFilterNodeTick,
          styles.dlFilterNodeTickFlex
        )}
        onClick={this.handleTickClick}
        onKeyDown={this.handleTickKeyDown}
        tabIndex={0}
        role={'button'}
        data-attr={isOpened ? 'opened' : 'closed'}
      >
        <Spring
          from={{transform: 'rotate(0deg)'}}
          to={{transform: `rotate(${isOpened ? 90 : 0}deg)`}}
        >
          {({transform}) => (
            <animated.i
              className={classNames(
                'fas',
                'fa-chevron-right',
                styles.dlFilterNodeTickIcon
              )}
              style={{transform}}
            />
          )}
        </Spring>
        {label ? <FilterNodeLabel label={label} /> : null}
      </span>
    );
  }
}

FilterNodeTick.displayName = 'FilterNodeTick';

FilterNodeTick.propTypes = {
  isOpened: PropTypes.bool,
  label: PropTypes.string,
  toggleOpened: PropTypes.func.isRequired,
};

FilterNodeTick.defaultProps = {
  isOpened: false,
  label: undefined,
};

export default FilterNodeTick;
